/**
 * Mobile nav store.
 *
 * Registers the `mobileNav` Alpine store, a small piece of shared state read
 * and written by sibling components in the mobile nav drawer (the primary
 * accordion items and the secondary link grid) that don't otherwise share an
 * Alpine scope boundary.
 *
 * @store mobileNav
 *   anySubmenuOpen - True while any mobile nav drilldown submenu is open.
 */
document.addEventListener("alpine:init", () => {
  Alpine.store("mobileNav", {
    anySubmenuOpen: false,
  });
});
